import {Calendar} from "react-feather";
import {DropdownOption} from "components";

const actualYear = new Date().getFullYear();

export const buildYearOptions = (rule: number = 5) => {
  const options: DropdownOption[] = [];
  for (let i = 0; i <= rule; i++) {
    options.push({
      icon: Calendar,
      label: `${actualYear - i}`,
      value: `${actualYear - i}`,
    });
  }
  return {options, actualYear};
};
